module.exports = __webpack_public_path__ + "img/tips6_2.08a728a0.png";